import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PostDetailModal from '../components/PostDetailModal';
import './ViewPostPage.css';

const ViewPostPage = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);
  const [postUpdated, setPostUpdated] = useState(false);

  const handleClose = () => {
    setIsVisible(false);
    // Si el post fue actualizado, notificar a CalendarView
    if (postUpdated) {
      // Guardar en localStorage (para compatibilidad con múltiples tabs)
      localStorage.setItem('postUpdatedId', postId);

      // Disparar evento personalizado para que CalendarView lo detecte inmediatamente
      const event = new CustomEvent('postUpdated', {
        detail: { postId: parseInt(postId) }
      });
      window.dispatchEvent(event);
    }
    // Redirigir al CalendarView (cuando viene desde email no hay historial previo)
    setTimeout(() => {
      navigate('/');
    }, 300);
  };

  const handleUpdate = () => {
    // Marcar que el post fue actualizado
    setPostUpdated(true);
  };

  if (!isVisible) {
    return null;
  }

  // Mostrar el modal del post directamente
  // fromEmailLink=true indica que viene de un enlace de email y debe usar el endpoint especial
  return (
    <div className="view-post-page">
      {postId && (
        <PostDetailModal
          postId={parseInt(postId)}
          onClose={handleClose}
          onUpdate={handleUpdate}
          fromEmailLink={true}
        />
      )}
    </div>
  );
};

export default ViewPostPage;
